module.exports = __webpack_public_path__ + "static/media/test29.39597af8.jpeg";